import React from 'react';
import { Link } from 'react-router-dom';
import { Button, chakra, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../../../App/ChakraTheme';

import Loader from '../../../../components/Loader';
import { LongArrowLeftIcon } from '../../../../components/icons';
import { useIsMobile } from '../../../../hooks/isMobile';

interface TitleProps {
  route: string;
  isSaveAvailable: boolean;
  unitName?: string;
  isUnitLoading: boolean;
  isExplore?: boolean;
  buttonText?: string;
}

const Title: React.FC<TitleProps> = ({
  route,
  isSaveAvailable,
  unitName,
  isUnitLoading,
  children,
  isExplore,
  buttonText = 'Back To Class',
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <chakra.header
      position="relative"
      paddingTop="20px"
      paddingBottom="20px"
      borderBottom="1px solid rgba(213, 214, 222, 0.5)"
      display="flex"
      justifyContent="center"
      alignItems="center"
      pl={['60px', '60px', '170px']}
      style={isExplore ? { padding: '16px 0px' } : {}}
    >
      <Button
        position="absolute"
        transform="translateY(-50%)"
        left="32px"
        top="50%"
        display="flex"
        align-items="center"
        color="rgb(16, 46, 142)"
        as={Link}
        colorScheme="blue"
        fontWeight="normal"
        sx={{
          '& svg': { transition: 'all 250ms ease-in-out' },
          '&:hover svg': {
            transform: 'translateX(-12px)',
          },
        }}
        textStyle="bodyMedium"
        aria-label="back"
        leftIcon={<LongArrowLeftIcon boxSize="16px" />}
        variant="link"
        to={route}
        onClick={(e) => {
          if (isSaveAvailable) {
            alert('Please save all changes');
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
          return true;
        }}
        className="back"
      >
        {t('general.back')}
      </Button>
      {isUnitLoading ? (
        <Loader />
      ) : (
        <>
          <Text
            as="h1"
            textStyle="h4"
            style={{
              padding: `0 ${spacing.BASE_PLUS}`,
              fontSize: isMobile ? '18px' : '24px',
              marginLeft: isMobile ? '30px' : '0',
            }}
            title={unitName || 'Unit'}
            data-lines="4"
          >
            {unitName || 'Unit'}
          </Text>
          {children}
        </>
      )}
    </chakra.header>
  );
};

export default Title;
